<template>
  <thead>
    <!-- Header Row 1: Months/Years -->
    <tr v-if="monthHeaders && monthHeaders.length > 0">
      <th class="col-issue" :rowspan="3">Issue</th>
      <th class="col-sum" :rowspan="3">Sum(h)</th>
      <th
        v-for="(month, idx) in monthHeaders"
        :key="`month-${idx}`"
        :colspan="month.colspan"
        class="col-month"
      >
        <div>{{ month.label }}</div>
      </th>
    </tr>

    <!-- Header Row 2: Weeks -->
    <tr v-if="weekHeaders && weekHeaders.length > 0">
      <th
        v-for="(week, idx) in weekHeaders"
        :key="`week-${idx}`"
        :colspan="week.colspan"
        :class="['col-week', { 'weekend-label': week.label === 'Bảy' || week.label === 'CN' }]"
      >
        <div>{{ week.label }}</div>
      </th>
    </tr>

    <!-- Header Row 3: Day Ranges or Day Numbers -->
    <tr>
      <th
        v-for="day in dayColumns"
        :key="`range-${day.date}`"
        :class="viewMode === 'day' ? 'col-day-number' : 'col-day-range'"
      >
        <div class="col-day-range-value">{{ viewMode === 'day' ? day.dayNumber : day.dayName }}</div>
      </th>
    </tr>
  </thead>
</template>

<script>
export default {
  name: "LogworkTableHeader",
  props: {
    monthHeaders: { type: Array, required: true },
    weekHeaders: { type: Array, required: true },
    dayColumns: { type: Array, required: true },
    viewMode: { type: String, default: "week" }
  }
};
</script>

<style scoped>
/* General Header Styles */
th {
  text-align: center;
  vertical-align: middle;
  /* border: 1px solid #fff; */
  padding: 4px;
  font-weight: 600;
  font-size: 13px;
  box-sizing: border-box;
}

.table-bordered thead th, .table-bordered thead td {
  border-bottom: 0px solid #d8dbe0;
}

/* Issue and Sum Columns */
.col-issue,
.col-sum {
  background-color: #007bff; /* Bright Blue */
  color: #fff;
}

.col-issue {
  min-width: 150px;
  text-align: left;
  padding-left: 15px;
}

.col-sum {
  min-width: 60px;
}

/* Month Header */
.col-month {
  background-color: #007bff; /* Bright Blue */
  color: #fff;
  height: 35px;
  text-align: center;
  vertical-align: middle;
}

/* Week Header */
.col-week {
  background-color: #B5D1F3 !important; /* Bright Blue */
  color: #000 !important;
  height: 30px;
  text-align: center;
  vertical-align: middle;
}

.weekend-label {
  color: #F03D3E !important;
  background-color: #FFE2E2 !important;
  padding: 2px 4px;
  border-radius: 4px;
}

/* Day Range Header */
.col-day-range, .col-day-number {
  background-color: #007bff; /* Light Gray Blue */
  color: #fff;
  height: 30px;
  text-align: center;

  .col-day-range-value {
    min-width: 35px;
    text-align: center;;
  }
}
</style>
